import styled from 'styled-components'
import Card from 'styles/Card'

const SidebarCard = styled(Card)`
  padding: 0 !important;
`

export default SidebarCard
